import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "center-box" }
const _hoisted_3 = { class: "msg-wrap" }
const _hoisted_4 = { class: "msg" }

interface Props {
  message?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadWaitSpinner',
  props: {
    message: { default: 'データロード中...' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner-wrap" }, [
            _createElementVNode("i", { class: "fa-3x fas fa-spinner fa-spin" })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "message", {}, () => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1)
            ])
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-backdrop" }, null, -1))
      ])
    ]),
    _: 3
  }))
}
}

})